<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="popupTitle"
        class="popup-checksendingmail"
        :closeOnClickOverlay="false"
        @closed="$emit('close')"
    >
        <template slot="default">
            <div class="dialog__default">
                <p>{{ popupMessage }}</p>

                <div class="mt-3">
                    <CompassFormItem
                        :label="popupInputLabel"
                        :error="errorMessage"
                        :disabled="mode !== 'edit'"
                    >
                        <CompassInput
                            ref="popupCheckSendingEmailInput"
                            v-model="email"
                            class="wp-10"
                            :disabled="mode !== 'edit'"
                            :readonly="false"
                            :placeholder="$t.__('common.labels.email')"
                            :error="isEmailError"
                        />
                    </CompassFormItem>
                </div>

                <CompassAlert
                    :description="$t.__('popups.PopupCheckSendingEmail.click_email_link')"
                    :showClose="false"
                    class="mb-0 mt-3"
                />
            </div>
        </template>
        <template slot="footer">
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="$emit('close')"
                />
                <CompassButton
                    ref="buttonSendValidationEmail"
                    :label="popupSubmitButtonLabel"
                    :disabled="isEmailError"
                    class="ml-3"
                    @click="onSubmit()"
                />
            </div>
        </template>
    </CompassDialog>
</template>

<script>
import OnboardingEmailApi from 'api/onboarding/email/onboardingEmail.js';
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapStateUser, mapActions: mapActionsUser } = createNamespacedHelpers('user');

export default {
    props: {
        mode: {
            type: String,
            required: false,
            default: 'checking',
        },
    },
    data() {
        return {
            showModal: true,
            email: '',
            errorMessage: '',
        };
    },
    computed: {
        ...mapStateUser({
            senderEmail: 'senderEmail',
            pendingEmail: 'pendingEmail',
        }),
        isEmptyEmail() {
            return this.email.length === 0;
        },
        isEmailError() {
            return this.errorMessage.length > 0;
        },
        isCheckingMode() {
            return this.mode === 'checking';
        },
        popupMessage() {
            return this.isCheckingMode
                ? this.$l10n.__(
                      "Pour garantir l'envoi de vos emails depuis Sellsy et assurer votre sécurité, vous devez vérifier votre adresse email d'expédition.",
                  )
                : this.$l10n.__(
                      'Saisissez la nouvelle adresse email d’expédition que vous souhaitez utiliser pour l’envoi de vos emails depuis Sellsy.',
                  );
        },
        popupTitle() {
            return this.isCheckingMode
                ? this.$l10n.__("Vérifier mon adresse email d'expédition")
                : this.$l10n.__("Modifier l'adresse email d'expédition");
        },
        popupInputLabel() {
            return this.isCheckingMode
                ? this.$l10n.__("Adresse email d'expédition")
                : this.$l10n.__("Nouvelle adresse email d'expédition");
        },
        popupSubmitButtonLabel() {
            return this.isCheckingMode
                ? this.$l10n.__("Envoyer l'email de vérification")
                : this.$l10n.__('Modifier');
        },
    },
    watch: {
        email: function (newEmail) {
            this.errorMessage =
                this.pendingEmail !== newEmail
                    ? ''
                    : this.$l10n.__('Cet email est déjà en cours de vérification');
        },
    },
    mounted() {
        this.email = this.senderEmail;
    },
    methods: {
        ...mapActionsUser(['sendVerificationEmail']),
        onSubmit() {
            this.mode !== 'edit' ? this.sendValidationEmail() : this.modifyValidationEmail();
        },
        sendValidationEmail() {
            this.sendVerificationEmail({ email: this.email })
                .then((response) => {
                    this.displayToast(response.type, response.message);
                })
                .catch((error) => {
                    this.displayToast(error.type, error.message);
                });
            this.$emit('close');
        },
        modifyValidationEmail() {
            this.errorMessage = this.isEmptyEmail ? this.$l10n.__('Ce champ est obligatoire.') : '';
            this.errorMessage =
                this.email === this.senderEmail
                    ? this.$l10n.__(
                          "L'adresse email ne peut pas être identique à celle utilisée actuellement.",
                      )
                    : this.errorMessage;
            if (!this.isEmailError) {
                OnboardingEmailApi.validateEmail(this.email)
                    .then(({ verified }) => {
                        if (verified) {
                            this.errorMessage = this.$l10n.__(
                                "L'adresse email ne peut pas être identique à celle utilisée actuellement.",
                            );
                        } else {
                            this.$trigger('checkingEmail:senderEmailChange', this.email);
                            this.$emit('close');
                        }
                    })
                    .catch(({ code }) => {
                        if (code === 400) {
                            this.errorMessage = this.$l10n.__('Le format est incorrect');
                        }
                    });
            }
        },
        displayToast(type, text) {
            this.$pushToast({
                type,
                text,
                close: true,
                unique: true,
                icon: true,
                timeout: 4000,
            });
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';

.compass-dialog.popup-checksendingmail {
    z-index: 2006 !important;

    .dialog {
        &__header {
            display: flex;
            justify-content: space-between;
            padding: 24px 32px;
        }

        &__default {
            padding-bottom: 24px;
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }
}
</style>
